import { useState } from "react";
import client, { formatApiErrorDetail, setToken } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 8) return toast.error("New password must be at least 8 characters");
    if (form.new_password !== form.confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      const { data } = await client.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      setToken(data.access_token);
      toast.success("Password updated — other sessions were signed out");
      setForm({ current_password: "", new_password: "", confirm: "" });
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Change password</DialogTitle>
          <DialogDescription>Minimum 8 characters. Every other active session will be signed out.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label className="text-[10px] uppercase tracking-widest text-slate-500">Current password</Label>
            <Input type="password" required data-testid="pw-current" className="mt-1 h-10 border-slate-200" value={form.current_password} onChange={set("current_password")} />
          </div>
          <div>
            <Label className="text-[10px] uppercase tracking-widest text-slate-500">New password</Label>
            <Input type="password" required minLength={8} data-testid="pw-new" className="mt-1 h-10 border-slate-200" value={form.new_password} onChange={set("new_password")} />
          </div>
          <div>
            <Label className="text-[10px] uppercase tracking-widest text-slate-500">Confirm new password</Label>
            <Input type="password" required data-testid="pw-confirm" className="mt-1 h-10 border-slate-200" value={form.confirm} onChange={set("confirm")} />
          </div>
          <Button type="submit" disabled={busy} data-testid="pw-submit" className="h-10 w-full rounded-md bg-slate-900 text-white hover:bg-slate-800">{busy ? "Updating…" : "Update password"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
